import { render, staticRenderFns } from "./ConfirmPurchasePrice.vue?vue&type=template&id=13ff634c&scoped=true&"
import script from "./ConfirmPurchasePrice.vue?vue&type=script&lang=js&"
export * from "./ConfirmPurchasePrice.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPurchasePrice.vue?vue&type=style&index=0&id=13ff634c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ff634c",
  null
  
)

export default component.exports